import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

export const MinDeliveryDate = () => {
    const [minDate, setMinDay] = useState(0);
    const currentDate = dayjs().toDate();
    const currentDay = currentDate.getDay();

    // Call getMinDay once on component build
    useEffect(() => {
        GetMinDay(currentDay, setMinDay);
    }, [currentDay]);

    return minDate;
};

// 'getMinDay' calculates the first available delivery date
export const GetMinDay = (crtDay: number, setMinDay: any) => {
    setMinDay(0);
};

// calculates the first available delivery date
export const getMinDeliveryDate = (pickedDate: Date = dayjs().toDate()) => {
    return 0;
};

// 'isWeekday' filters Saturday, Sunday and Monday from the weekarray for further processing
export const isWeekday = (date: Date) => {
    const day = date.getDay();
    return day !== 0 && day !== 1 && day !== 6;
};
